import { SPACING } from "@/generic/config";
import { Box } from "@chakra-ui/react";
import { ReactNode } from "react";
import Card from "./Card";
import useModel from "./hooks/useModel";
import Menu from "./Menu";
import { isDesktop } from "react-device-detect";

type EditorParentProps = {
    title: string,
    titleAddon?: ReactNode,
    description?: string | ReactNode,
    children?: ReactNode,
    toolbar?: ReturnType<typeof useModel>["toolbar"]
    actions?: Array<EditorAction>
}

const EditorParent = ({ title, titleAddon, description, children, toolbar, actions }: EditorParentProps) => {
    return (
        <Box ml={isDesktop ? SPACING : 0} height={"100%"}>
            <Card
                title={title}
                titleAddon={titleAddon}
                description={description}
                rightAddon={actions ? <Menu title="Actions" items={actions} /> : undefined}
            >
                {children}
                {toolbar}
            </Card>
        </Box>
    )
}

export default EditorParent;

export type EditorAction = {
    title: string,
    onClick: () => void
}